export { default as WhatIsIt } from './WhatIsIt';
